/**
 * RoomSummaryCard
 * ----------------
 * Renders the per-room column headers, including name, location, address,
 * and status chips.
 */
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const RoomSummaryCard = ({ room }) => (
  <Paper key={room.id} variant="outlined" sx={{ p: 1.5 }}>
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {room.name}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {room.locationName}
    </Typography>
    {room.locationAddress && (
      <Typography variant="caption" color="text.secondary">
        {room.locationAddress}
      </Typography>
    )}
    <Stack direction="row" spacing={1} sx={{ mt: 1 }} alignItems="center">
      <Chip size="small" label={room.city} />
      <Chip size="small" label={room.status} variant="outlined" />
    </Stack>
  </Paper>
);

export default RoomSummaryCard;